import { FC } from 'react'
import { getPlayed } from '../controllers/stats'
import { localStoragePrefix } from '../config'
import ArchiveAnnouncement from './PostGameMessages/ArchiveAnnouncement'
import DidYouKnow from './DidYouKnow'
import FeedbackBox from './FeedbackBox'
import getLocalDate from '../util/getLocalDate'
import logGoogleEvent from '../util/logEvent'

type Props = {
	openModal(modalName: string): void
}

const PostGameMessage: FC<Props> = ({ openModal }) => {
	const played = getPlayed()

	if (played === 1) {
		return <DidYouKnow openModal={openModal} />
	}

	if (played === 2) {
		return <FeedbackBox />
	}

	if (played >= 3) {
		const aaPGMId = 'archiveAnnouncement'
		const aaShownBefore = !!getPGMSeenAt(aaPGMId)
		if (shouldShowPGM(aaPGMId, '2026-03-18', '2026-05-18')) {
			if (!aaShownBefore) logPGMShownEvent(aaPGMId)
			return <ArchiveAnnouncement />
		}
	}

	return null
}

export default PostGameMessage

// Helpers
// ========================================================================

const pgmSeenAtStorageKey = (pgmId: string) => `${localStoragePrefix}pgm_${pgmId}SeenAt`

const getPGMSeenAt = (pgmId: string) => localStorage.getItem(pgmSeenAtStorageKey(pgmId))

const logPGMShownEvent = (pgmId: string) => logGoogleEvent(`pgm_${pgmId}_shown`)

function shouldShowPGM(pgmId: string, startDate?: string, endDate?: string): boolean {
	const today = getLocalDate()

	// is the message embargoed?
	if (startDate && today < startDate) return false

	// is the message out of date?
	if (endDate && today > endDate) return false

	const pgmSeenAt = getPGMSeenAt(pgmId)
	if (pgmSeenAt && pgmSeenAt !== today) {
		// they've already seen the message in the past
		return false
	}

	if (pgmSeenAt === today) {
		// keep showing them the message today
		return true
	}

	// show it to them for the first time
	localStorage.setItem(pgmSeenAtStorageKey(pgmId), today)
	return true
}
